
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Licenses from "../pages/licenses/page";
import Contact from "../pages/contact/page";
import Events from "../pages/events/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/licenses",
    element: <Licenses />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
